<template>
<app-layout>

   <template v-slot:adminnav >
  </template> 

 <div>
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div>
          <div>
            <div class="row">
              <div class="col">
                <jet-button
                  class="
                    bg-blue-500
                    rounded
                    text-white
                    hover:bg-blue-500 hover:no-underline
                    px-2
                    cursor-pointer
                    text-sm
                  "
                  @click="goToCreate"
                >
                  Add {{ moduleName }}</jet-button
                >
              </div>
            </div>
            <div class="mt-2">
              <div
                class="
                  bg-white
                  overflow-hidden
                  shadow-xl
                  px-2
                  py-2
                  sm:rounded-lg
                "
              >
                <BsIndex :slug="slug" :dataRoute="moduleRoute" :headersDef="headers">
                </BsIndex>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
   

  </app-layout>
</template>
<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import BsIndex from "@/Base/BsIndex.vue";
//import { DxDataGrid } from 'devextreme-vue/data-grid';
import DataSource from "devextreme/data/data_source";
import "devextreme/data/odata/store";
import PageTitle from "@/Layouts/PageTitle.vue";

import JetNavLink from "@/Jetstream/NavLink.vue";
import JetButton from "@/Jetstream/Button.vue";

let collapsed = false;

export default {
  props: {
    moduleRoute: String,
    headers: Array,
    moduleName: String,
    slug:String,
  },
  components: {
    AppLayout,
    BsIndex,
    PageTitle,
    JetNavLink,
    JetButton,
  },
  data() {
    return {
      title: this.moduleName,
      dataSource: new DataSource({
        store: {
          type: "odata",
          url: "https://js.devexpress.com/Demos/SalesViewer/odata/DaySaleDtoes",
          key: "Id",
          beforeSend: function (request) {
            request.params.startDate = "2020-05-10";
            request.params.endDate = "2020-05-15";
          },
        },
      }),
      grouping: {
        contextMenuEnabled: true,
        autoExpandAll: false,
        expandMode: "rowClick",
      },
      groupPanel: {
        visible: true,
      },
      columns: ["Product", "Region", "SaleDate", "Channel", "Customer"],
      pageSizes: [10, 25, 50, 100],
      onContentReady: function (e) {
        if (!collapsed) {
          e.component.expandRow(["EnviroCare"]);
          collapsed = true;
        }
      },
    };
  },
  methods: {
    sayHelloWorld() {
      alert("Hello world!");
    },
    goToCreate() {
       this.$inertia.get('/'+this.slug+'/'+this.moduleRoute + '/create');
     // this.$inertia.get("/tc-configurations/branchconfigcreate");
    },
  },
  data: function () {
    return {
      title: this.moduleRoute + " List",
    };
  },
  mounted() {
   // console.log("moduleRoute");
   // console.log(this.moduleRoute);

    //console.log("Examples component mounted");
  },
};
</script>
